import { JdPokerComponent } from "./jd_poker_component";
import { JdDealCardsEffect } from "./jd_deal_cards_effect";
import { JdBetMoveEffect } from "./jd_bet_move_effect";
import { JdSeatConfig } from "./jd_seat_state_component";
import { HandCardEffect } from "./jd_handcard_effect";
import { ColorSliderComponent } from "../../../../texasholdem/module/table/component/colorslider_component";
import { PokerCommonColor } from "../../../../k9/module/table/component/poker_com_color";
import GameUtil from "../../../../../utility/game_util";
import TablePlayerAvatar from "../../../../table/components/table_player_avatar";

const {ccclass, property} = cc._decorator;

//处理座位UI
@ccclass
export class JdSeatComponent extends cc.Component {
    //0-红 1-绿 2-黄
    @property(ColorSliderComponent)
    countDown:ColorSliderComponent = null;

    operatorDes:cc.Sprite = null;

    @property(cc.Label)
    userGold:cc.Label = null;

    @property(cc.Node)
    smallPoker:cc.Node = null;

    @property(cc.Node)
    active:cc.Node = null;

    @property(cc.Label)
    serverID:cc.Label = null;

    @property(cc.Node)
    mask:cc.Node = null;

    @property([PokerCommonColor])
    mHands:PokerCommonColor[] = [];

    @property(cc.Node)
    winner:cc.Node = null;

    @property([JdDealCardsEffect])
    twoSmallCards:JdDealCardsEffect[] = [];

    @property(JdBetMoveEffect)
    betMoveEffect:JdBetMoveEffect = null;

    @property(cc.Node)
    betEndNode:cc.Node = null;
    //金币适配控制
    @property(cc.Node)
    goldTarget:cc.Node = null;

    @property(cc.Label)
    goldNumb:cc.Label = null;

    @property(cc.Node)
    myGoldNode:cc.Node = null;

    @property(cc.Node)
    goldRoot:cc.Node = null;

    //操作显示
    @property(cc.Node)
    operatorNode:cc.Node = null;

    @property(cc.Node)
    animationNode:cc.Node = null;
    //动画 operator 
    @property(cc.Node)
    operatorAnim:cc.Node = null;
    //最大牌型
    @property(cc.Node)
    maxCardNode:cc.Node = null;

    @property([cc.Node])
    animationNodes:cc.Node[] = [];

    @property([cc.Node])
    smallCards:cc.Node[] = [];

    @property(cc.Node)
    winAnim:cc.Node = null;

    @property(cc.Node)
    patternNode:cc.Node = null;

    @property(HandCardEffect)
    handCardEffect:HandCardEffect = null;

    @property(cc.Node)
    gradesNode:cc.Node = null;

    @property(cc.Node)
    effectNode:cc.Node = null;

    @property(cc.Node)
    debugInfo:cc.Node = null;

    @property(cc.Animation)
    scoreAnim:cc.Animation = null;

    @property([cc.Label])
    scores:cc.Label[] = [];

    @property(cc.Node)
    avatarNode:cc.Node = null;

    @property(cc.Node)
    smallCtrlNode:cc.Node = null;

    setServerID(serverID:number){
        this.serverID.string = serverID.toString();
    }

    showHands(isShow:boolean = false){
        for (let hand of this.mHands) {
           isShow ? hand.show():hand.hide();
        }
    }

    //牌桌状态
    seatState(isIdle:boolean){
        this.active.active = !isIdle;
    }

    //更新每个位置的适配
    updateSeatInfo(seatConfig:JdSeatConfig){
        this.smallPoker.position = seatConfig.smallCard;
        this.myGoldNode.position = seatConfig.goldVec2;
        this.goldTarget.position = seatConfig.goldTarget;
        this.goldNumb.node.position = seatConfig.goldNumb;
    }

    
    showScore(score:number){
        this.hideScores()
        this.scoreAnim.play();

        let coin = GameUtil.currencyFormatting(score,2,true);
        let str = (score > 0 ? '+':'') + coin;
        
        let index = score < 0 ? 0 : 1;
        this.scores[index].node.active = true;
        this.scores[index].string = str;
    }

    hideScores(){
        for (const score of this.scores) {
            score.node.active = false;
        }
    }

}
